import React from 'react';

import { startCase } from 'lodash';

import ManagedInput from 'components/form/managed_input';
import { propertyAttributes } from 'bundles/research/index/research_constants';
import { displayedKeys, requiredFields as defaultRequiredFields } from './helpers';

interface Props {
  properties: Record<string, any>[];
  propertyDefaults: Record<string, any>;
  attributesMap: Record<string, number | null>;
  attributes?: string[];
  requiredFields?: string[];
  onSelectKey: (key: string, id: number) => void;
  onSelectAll: (id: number) => void;
}

export default function PropertyMergeTable({
  properties,
  propertyDefaults,
  attributesMap,
  attributes = propertyAttributes,
  requiredFields = defaultRequiredFields,
  onSelectKey,
  onSelectAll
}: Props) {
  const shownKeys = displayedKeys(properties, propertyDefaults, attributes);

  const allSelected = (id: number) => shownKeys.every(key => attributesMap[key] === id);

  return (
    <div className="table-container">
      <table className="table">
        <thead>
          <tr>
            <th>Fields</th>
            {properties.map((property, index) => (
              <th key={property.id}>
                <ManagedInput
                  checked={allSelected(property.id)}
                  label={`Property ${index + 1}`}
                  type="checkbox"
                  onChange={() => onSelectAll(property.id)}
                />
              </th>
            ))}
            <th>Merged Property</th>
          </tr>
        </thead>
        <tbody>
          {shownKeys.map((key) => {
            const selected = properties.find(property => property.id === attributesMap[key]);

            return (
              <tr key={key}>
                <td>
                  <label className="form-label">{startCase(key)}</label>
                  {requiredFields.includes(key) && <span className="text-danger">*</span>}
                </td>
                {properties.map(property => (
                  <td key={property.id + key}>
                    <ManagedInput
                      checked={attributesMap[key] === property.id}
                      label={Array.isArray(property[key]) ? property[key].join(', ') : property[key]}
                      type="checkbox"
                      onChange={() => onSelectKey(key, property.id)}
                    />
                  </td>
                ))}
                <td>{selected ? selected[key] : ''}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
